<template>
  <div>
    <b-row>
      <b-col class="row-align-left">
        <label >What race best describes you?</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" lg="3">
        <label class="float-left">
          <input type="radio" v-model="$v.race.$model" class="option-input radio" :class="{ 'invalid-radio-button': raceState }" name="rd6" value="White">
          White
        </label>
      </b-col>
      <b-col sm="6" lg="4">        
        <label class="float-left">
          <input type="radio" v-model="$v.race.$model" class="option-input radio" :class="{ 'invalid-radio-button': raceState }" name="rd6" value="Black/African American">
          Black/African American
        </label>
      </b-col>
      <b-col sm="6" lg="5">       
        <label class="float-left">
          <input type="radio" v-model="$v.race.$model" class="option-input radio" :class="{ 'invalid-radio-button': raceState }" name="rd6" value="Asian">
          Asian
        </label>

      </b-col>
    
      <b-col sm="6" lg="3">        
        <label class="float-left">
          <input type="radio" v-model="$v.race.$model" class="option-input radio" :class="{ 'invalid-radio-button': raceState }" name="rd6" value="Bi-Racial">
          Bi-Racial
        </label>
      </b-col>
      <b-col sm="6" lg="4">      
        <label class="float-left">
          <input type="radio" v-model="$v.race.$model" class="option-input radio" :class="{ 'invalid-radio-button': raceState }" name="rd6" value="Amercian Indian/Alaska Native">
          Amercian Indian/Alaska Native
        </label>
      </b-col>
      <b-col sm="6" lg="5">    
        <label class="float-left">
          <input type="radio" v-model="$v.race.$model" class="option-input radio" :class="{ 'invalid-radio-button': raceState }" name="rd6" value="Native Hawaiian/Other Pacific Islander">
          Native Hawaiian/Other Pacific Islander
        </label>
        </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="12" lg="4" class="row-align-left">
        <label >What ethnicity best describes you?</label>
      </b-col>

      <b-col sm="12" lg="8" >
        <b-row>
          <b-col md="6">
            
            <label class="float-left" >
          <input
            type="radio"
            v-model="$v.ethnicity.$model"
            class="option-input radio"
            :class="{ 'invalid-radio-button': ethnicityState }"
            name="rd7"
            :value="2"
          >
          Non-Hispanic/Latino
        </label>
          </b-col>
          <b-col md="6">
            
              <label class="float-left" >
          <input
            type="radio"
            v-model="$v.ethnicity.$model"
            class="option-input radio"
            :class="{ 'invalid-radio-button': ethnicityState }"
            name="rd7"
            :value="1"
          >
          Hispanic/Latino
        </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Race: {{ surveyData.Race}} - Ethnicity: {{ surveyData.Ethnicity }} -->
    <survey-nav :step="4" :ShowErrorMsg="showErrorMsg" @move-next="moveNext" @move-previous="movePrevious"></survey-nav>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import surveyNav from "@/components/SurveyNav";

export default {
  name: "survey-step4",
  props: ["surveyData", "isValid"],
  data: () => ({
    race: null,
    ethnicity: null,
    raceRadios: [
      { text: "White", value: "White" },
      { text: "Black/African American", value: "Black/African American" },
      { text: "Asian", value: "Asian" },
      { text: "Bi-racial", value: "Bi-racial" },
      {
        text: "American Indian/Alaska Native",
        value: "American Indian/Alaska Native"
      },
      {
        text: "Native Hawaiian/Other Pacific Islander",
        value: "Native Hawaiian/Other Pacific Islander"
      }
    ],    
    showErrorMsg: false
  }),
  components: {
    surveyNav
  },
  validations: {
    race: {
      required
    },
    ethnicity: {
      required
    }
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) this.$emit("move-next");
      else{
        this.showErrorMsg = true;
        this.$v.$touch();
      } 
    },
     movePrevious() {
      this.$emit("move-previous");
    },
    onCreated() {      
      this.race = this.surveyData.Race;
      this.ethnicity = this.surveyData.Ethnicity;
    }
  },
  computed:{
    //Radio buttons must return a !result
    ethnicityState() {
      return this.$v.ethnicity.$dirty ? !this.$v.ethnicity.required : null;
    },
    raceState() {
      return this.$v.race.$dirty ? !this.$v.race.required : null;
    }
  },
  watch: {
    race() {
      console.log("watching race");
      if (this.$v.race.required) this.surveyData.Race = this.race;
    },
    ethnicity() {
      console.log("watching ethnicity");
      if (this.$v.ethnicity.required) this.surveyData.Ethnicity = this.ethnicity;
    }

  },
  created() {
    this.onCreated();
  }
};
</script>

<style scoped>
.invalid-radio-button{
  background-color: red;
}
</style>
